import { createStore } from "vuex";
import { commStore } from "@/store/modules/commStore";
import createPersistedState from 'vuex-persistedstate';

export default createStore({
    modules: {
        commStore
    },
    plugins: [
        createPersistedState()
    ]
})